import { type ReactNode } from 'react';
import { useHasNoLocation } from '@pkgs/components/hooks/useHasNoLocation';
import { useAppContext } from '@pkgs/components/hooks/useAppContext';
import { Tooltip } from '@base-ui/react/tooltip';
import { type Side } from '@base-ui/react/internals/useAnchorPositioning';

import styles from './SearchAlertTooltip.module.css';
import searchAlertStyles from './SearchAlert.module.css';


type SearchAlertTooltipProps = {
  children: ReactNode;
  side?: Side;
};
export const SearchAlertTooltip = ({ children, side = 'bottom' }: SearchAlertTooltipProps) => {
  const hasNoLocation = useHasNoLocation();
  const { t } = useAppContext();

  return (
      <Tooltip.Root>
        <Tooltip.Trigger
          disabled={!hasNoLocation}
          render={<div className={searchAlertStyles.tooltipWrapper} />}
        >
          {children}
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Positioner side={side} align="center" sideOffset={8}>
            <Tooltip.Popup className={styles.tooltip}>
              <span>{t('search.searchAlert.ctaCard.button.disabled.message')}</span>
            </Tooltip.Popup>
          </Tooltip.Positioner>
        </Tooltip.Portal>
      </Tooltip.Root>
  );
};
